export const BASE_OPTION = {// 全局基础配置

}
